// extracted by mini-css-extract-plugin
export var h1 = "header-module--h-1--1rImJ";
export var h2 = "header-module--h-2--1cJjc";
export var h3 = "header-module--h-3--1RLct";
export var genHeader = "header-module--gen-header--xnUIb";
export var p1 = "header-module--p-1--2PpCU";
export var p2 = "header-module--p-2--3fBW5";
export var p3 = "header-module--p-3--1UmIl";
export var header = "header-module--header--2K2b3";
export var menuButton = "header-module--menu-button--2uwMP";
export var siteTitle = "header-module--site-title--6K-gh";
export var navContainer = "header-module--nav-container--1Udh3";
export var navItem = "header-module--nav-item--2qBde";
export var mobileLinks = "header-module--mobile-links--4Dt98";
export var mobileActive = "header-module--mobile-active---Cn3n";
export var open = "header-module--open--2XEis";
export var active = "header-module--active--8yorc";
export var menuButtonContent = "header-module--menu-button-content--3rQsZ";
export var availableButton = "header-module--available-button--3GdMG";